import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "../../index";
import "./thumbnail.scss";

export const Thumbnail = ({
    icon = "mybsw",
    source = "",
    size = 'md',
    resizeMode = 'cover',
    onLoad = () => { },
    onError = () => { },
    altText

}) => {

    const [imageLoading, setImageLoading] = useState(true);

    const thumbnailClasses = [
        `bsw-thumbnail`,
        `bsw-thumbnail-size--${size}`,
        `${(source === '') ? "bsw-thumbnail-type--icon" : "bsw-thumbnail-type--image"}`,
    ].join(' ');

    const iconSize = {
        'xs': 'medium',
        'sm': 'medium',
        'md': 'medium',
        'lg': 'large'
    }

    const imageSize = {
        'xs': '50px',
        'sm': '60px',
        'md': '80px',
        'lg': '100px'
    }

    const imgOnLoadhandler = () => {
        setImageLoading(false);

        onLoad();
    }

    const imgOnErrorhandler = (e) => {
        onError();
    }

    const iconImg = <div className="bsw-thumbnail-icon">
        <Icon
            name={icon}
            set="brand"
            size={iconSize[`${size}`]}
            aria-label={altText}
        />
    </div>;

    return (
        <div className={thumbnailClasses}>
            {source
                ? <>
                    <img
                        src={source}
                        onLoad={imgOnLoadhandler}
                        alt={altText}
                        className={`bsw-thumbnail-img bsw-thumbnail-img--${resizeMode}`}
                        width={imageSize[`${size}`]}
                        height={imageSize[`${size}`]}
                        onError={imgOnErrorhandler}
                    />
                    {imageLoading && iconImg}
                </>
                :
                iconImg
            }
        </div>
    )

}

Thumbnail.propTypes = {
    icon: PropTypes.string,
    source: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    resizeMode: PropTypes.oneOf(['cover', 'contain', 'stretch', 'repeat ', 'center']),
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    altText: PropTypes.string

}